import React from 'react'
import FadeWrapper from '../../../components/transitions/FadeWrapper'
import { PageContent } from '../../../components/layout/PageContent'
import InventorySummary from '../summary/InventorySummary'

import Stats from './stats/Stats'

const Inventory: React.FC = () => {
  return (
    <FadeWrapper>
      <PageContent>
        <InventorySummary />
        <Stats />
      </PageContent>
    </FadeWrapper>
  )
}

export default Inventory
